import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { SiteConfigManager, useApplicationState } from '@atlas/core';
import { paymentRoutes } from '@atlas/routing';

const EXCLUDED_ROUTE_SEGMENTS = [
  paymentRoutes.deposit,
  paymentRoutes.withdrawal,
  paymentRoutes.transactionHistory,
];

export const useEmailVerificationBannerVisibility = () => {
  const { pathname } = useLocation();
  const { account, authenticated } = useApplicationState();

  return useMemo(() => {
    const showEmailVerificationBanner = SiteConfigManager.getConfig(
      'config.config.accountProfile.showEmailVerificationBanner',
      false,
    );

    const isExcludedRoute =
      EXCLUDED_ROUTE_SEGMENTS.some(segment => pathname.includes(segment)) ||
      pathname.includes('/game') ||
      pathname.includes('/virtual-game');

    return Boolean(
      showEmailVerificationBanner && authenticated && !account?.emailVerified && !isExcludedRoute,
    );
  }, [account?.emailVerified, authenticated, pathname]);
};
